import { SELECIONAR_RESERVAS_TRANSFERENCIA } from '../types'

export default function selecionarReservasTransferencia (reservas) {
  return {
    type: SELECIONAR_RESERVAS_TRANSFERENCIA,
    payload: reservas
  }
}
